export const companyDocumentKeys = {
	categories: (profileTypeId: number) =>
		["company", "document-categories", profileTypeId] as const,
	documents: (companyId: number) =>
		["company", "documents", companyId] as const,
	auditLogs: (companyId: number, documentId: number) =>
		["company", "document-audit-logs", companyId, documentId] as const,
};
